export const formatCurrency = (amount, currency = 'usd') => {
  const safeAmount = Number.isFinite(amount) ? amount : 0;
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
  }).format(safeAmount / 100);
};

export function roundCentsToNearestDollar(amount) {
  const safeAmount = Number.isFinite(amount) ? amount : 0;
  return Math.round(safeAmount / 100) * 100;
}
